var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.data.thermal_bag_info
      ? _c("div", { staticClass: "thermal-bag-info" }, [
          _vm._v("\n        " + _vm._s(_vm.data.thermal_bag_info) + "\n    ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.data.thermal_bag_items.length == 0
      ? _c("div", { staticClass: "cart-crosssell" }, [
          _c("div", {
            staticClass: "cart-crosssell__items",
            attrs: {
              id: "lbx-crosssell-cart",
              "data-product-sku": _vm.data.sku
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.data.thermal_bag_items && _vm.data.thermal_bag_items.length
      ? _c("div", { staticClass: "cart-thermal-bag", attrs: { type: "" } }, [
          _c("h3", { staticClass: "cart-thermal-bag__title" }, [
            _vm._v("\n            Do Twojego zamówienia możesz dodać\n        ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "thermal_bag_items",
              staticClass: "cart-thermal-bag__items"
            },
            _vm._l(_vm.data.thermal_bag_items, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "cart-thermal-bag__item-wrapper",
                  attrs: {
                    "data-gtm-product-id": _vm.type + "-popup-" + item.gtm.id,
                    "gtm-element": "product-item"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "cart-thermal-bag__item",
                      attrs: { href: item.url, tabindex: "0" }
                    },
                    [
                      item.img
                        ? _c(
                            "div",
                            { staticClass: "cart-thermal-bag__item-img" },
                            [
                              _c("img", {
                                attrs: {
                                  src: item.img,
                                  alt: item.name ? item.name : ""
                                }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.name
                        ? _c(
                            "p",
                            { staticClass: "cart-thermal-bag__item-name" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(item.name) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "product_addtocart_form",
                      attrs: {
                        action: "/ajaxcart/index/add",
                        enctype: "multipart/form-data"
                      }
                    },
                    [
                      _c("input", {
                        attrs: { name: "form_key", type: "hidden" },
                        domProps: { value: _vm.formKey }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          id: "product_id",
                          type: "hidden",
                          name: "product"
                        },
                        domProps: { value: item.id }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          id: "listCategory",
                          type: "hidden",
                          name: "listCategory"
                        },
                        domProps: { value: item.gtm.list }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "product-item__btn",
                          attrs: {
                            type: "button",
                            "data-vue-init": "add-to-cart"
                          },
                          on: { click: _vm.addToCart }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(item.price) +
                              " zł\n                        "
                          ),
                          _c(
                            "span",
                            { staticClass: "button_icon" },
                            [
                              _c("CartIcon", {
                                staticClass: "icon icon-cart icon--inline",
                                attrs: {
                                  width: "28",
                                  height: "24",
                                  "view-box": "0 0 24 28"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(0, true)
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    (_vm.isMobile && _vm.data.thermal_bag_items.length > 1) ||
                    (_vm.isDesktop && _vm.data.thermal_bag_items.length > 3),
                  expression:
                    "\n                (isMobile && data.thermal_bag_items.length > 1) ||\n                (isDesktop && data.thermal_bag_items.length > 3)\n            "
                }
              ],
              ref: "arrows",
              staticClass: "cart-thermal-bag__switcher"
            },
            [
              _c(
                "button",
                {
                  ref: "arrowLeft",
                  staticClass: "btn btn--clear",
                  attrs: {
                    "aria-label": "Poprzedni produkt",
                    title: "Poprzedni produkt"
                  }
                },
                [
                  _c("span", {
                    staticStyle: { width: "22px", height: "22px" },
                    attrs: { "data-icon": "arrow-left-green" }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  ref: "arrowRight",
                  staticClass: "btn btn--clear",
                  attrs: {
                    "aria-label": "Kolejny produkt",
                    title: "Kolejny produkt"
                  }
                },
                [
                  _c("span", {
                    staticStyle: { width: "22px", height: "22px" },
                    attrs: { "data-icon": "arrow-right-green" }
                  })
                ]
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tooltip-max-price-info" }, [
      _c("p", [
        _vm._v("\n                        Podana cena jest ceną maksymalną"),
        _c("br"),
        _vm._v(" "),
        _c(
          "span",
          {
            attrs: {
              "data-tooltip-cms": "product_shipment_info",
              "data-toggle": "tooltip",
              "data-html": "true",
              "data-placement": "bottom",
              "data-original-title":
                '<div class="cms-block"><div·class="cms-block__content"><p>Proste zasady - realizujesz zam&oacute;wienie i kupujesz zarezerwowane produkty w wybranej aptece. Już ponad 2600 aptek w Apteline.pl!</p>\n                                <ul>\n                                <li>podana przy produktach nierefundowanych cena jest ceną maksymalną - cena sprzedaży ustalana jest przez aptekę</li>\n                                <li>miejsce odbioru: wybrana przez Ciebie apteka</li>\n                                <li>dostawa: zawsze GRATIS</li>\n                                <li>czas dostawy: maksymalnie 24 godziny (wyjątkiem mogą być weekendy i święta)</li>\n                                <li>większość zam&oacute;wień złożonych przed południem można odebrać tego samego dnia</li>\n                                <li>wiadomość sms ze statusem zam&oacute;wienia</li>\n                                <li>płatność w aptece przy odbiorze</li>\n                                <li>bezpieczeństwo: leki z hurtowni prosto do apteki</li>\n                                </ul></div></div>'
            }
          },
          [
            _c("span", { staticStyle: { "text-decoration": "underline" } }, [
              _vm._v(
                "\n                                Dowiedz się więcej\n                            "
              )
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }